module.exports = __webpack_public_path__ + "media/video-login.165e2a9e.mp4";